import { FileParameter } from "services/api/cplauthapi/CPLAuthAPI";

/* eslint @typescript-eslint/no-explicit-any: 0 */
export interface INewCompanyBrandingModel {
  logo?: FileParameter;
  favicon?: FileParameter;
  bodyFont?: FileParameter;
  headerFont?: FileParameter;
  companyBrandingFile?: FileParameter;
  isGeneratedCSSFile?: boolean;

  clientPortalName?: string;

  navbarBackgroundColour?: string;
  navbarTextColour?: string;
  navbarButtonColour?: string;
  navbarButtonTextColour?: string;
  navbarIconColour?: string;

  footerBackgroundColour?: string;
  footerTextColour?: string;
  footerButtonColour?: string;
  footerButtonTextColour?: string;

  toolbarBackgroundColour?: string;
  toolbarTextColour?: string;
  toolbarButtonColour?: string;
  toolbarButtonTextColour?: string;

  buttonPrimaryColour?: string;
  buttonSecondaryColour?: string;
  buttonSuccessColour?: string;
  buttonDangerColour?: string;
  buttonPrimaryTextColour?: string;
  buttonSecondaryTextColour?: string;
  buttonSuccessTextColour?: string;
  buttonDangerTextColour?: string;

  brandPrimaryColour?: string;
  brandSecondaryColour?: string;
  brandTertiaryColour?: string;

  fontHeadingColour?: string;
  fontBodyColour?: string;
  isHeaderTextBold: boolean;
  isHeaderTextItalic: boolean;
  isHeaderTextUnderlined: boolean;
}

export class NewCompanyBrandingModel implements INewCompanyBrandingModel {
  logo?: FileParameter;
  favicon?: FileParameter;
  bodyFont?: FileParameter;
  headerFont?: FileParameter;
  companyBrandingFile?: FileParameter;
  isGeneratedCSSFile?: boolean;

  clientPortalName?: string;

  navbarBackgroundColour?: string;
  navbarTextColour?: string;
  navbarButtonColour?: string;
  navbarButtonTextColour?: string;
  navbarIconColour?: string;

  footerBackgroundColour?: string;
  footerTextColour?: string;
  footerButtonColour?: string;
  footerButtonTextColour?: string;

  toolbarBackgroundColour?: string;
  toolbarTextColour?: string;
  toolbarButtonColour?: string;
  toolbarButtonTextColour?: string;

  buttonPrimaryColour?: string;
  buttonSecondaryColour?: string;
  buttonSuccessColour?: string;
  buttonDangerColour?: string;
  buttonPrimaryTextColour?: string;
  buttonSecondaryTextColour?: string;
  buttonSuccessTextColour?: string;
  buttonDangerTextColour?: string;

  brandPrimaryColour?: string;
  brandSecondaryColour?: string;
  brandTertiaryColour?: string;

  fontHeadingColour?: string;
  fontBodyColour?: string;
  isHeaderTextBold: boolean;
  isHeaderTextItalic: boolean;
  isHeaderTextUnderlined: boolean;

  constructor(data?: INewCompanyBrandingModel) {
    if (data) {
      for (const property in data) {
        if (Object.hasOwn(data, property)) (this as any)[property] = (data as any)[property];
      }
    }

    this.isHeaderTextBold = false;
    this.isHeaderTextItalic = false;
    this.isHeaderTextUnderlined = false;
  }
}
